const occurrences = []

export function addOccurrence(occurrence) {
    occurrences.push(occurrence)
}

export function getOccurrences() {
    return occurrences
}

export function clearOccurrences() {
    occurrences.length = 0
}